export const manifest = {
  screens: {
    scr_a9fhzy: { name: "Intro (Hook)", route: "/", position: {"x":1560,"y":220} },
    scr_vddupo: { name: "Question 1", route: "/", state: {"step":"quiz","currentQuestionIndex":0}, position: {"x":2960,"y":220} },
    scr_6vt42a: { name: "Question 4 (Harvard)", route: "/", state: {"step":"quiz","currentQuestionIndex":3}, position: {"x":4360,"y":220} },
    scr_ftto3h: { name: "Analyzing", route: "/", state: {"step":"loading"}, position: {"x":5760,"y":220} },
    scr_2yt5xu: { name: "Results", route: "/", state: {"step":"results"}, position: {"x":7160,"y":220} },
    scr_0yakiv: { name: "VSL", route: "/", state: {"step":"vsl"}, position: {"x":160,"y":220} },
  },
  sections: {
    sec_x6pspc: { name: "Assessment & Quiz Flow", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_x6pspc", children: [
      { kind: "screen", id: "scr_0yakiv" },
      { kind: "screen", id: "scr_a9fhzy" },
      { kind: "screen", id: "scr_vddupo" },
      { kind: "screen", id: "scr_6vt42a" },
      { kind: "screen", id: "scr_ftto3h" },
      { kind: "screen", id: "scr_2yt5xu" },
    ] },
  ],
}
